// Centralized query keys for React Query
export const diffKeys = {
  // Planner related queries
  planner: {
    getDiff: (diffId: string) => ['planner', 'get-diff', diffId] as const,
  },
} as const;
